var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React from 'react';
import { useTranslation, Trans } from 'react-i18next';
import Button from '../atoms/BaseButton';
import styled from 'styled-components';
import Dialog from '../atoms/Dialog';
import { useNavigate } from 'react-router-dom';
import { useRequest } from '../../hooks/requestHook';
import { useNotify } from '../../hooks/notificationHook';
import { Typography, Checkbox, FormGroup, FormControlLabel, Divider, Box, } from '@mui/material';
import { order as orderApi } from '../../api';
import DeliveryDocumentLink from '../atoms/deliveryDocumentLink';
var ExplanationText = styled(Typography).attrs({ variant: 'caption' })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  white-space: pre-line;\n  word-break: break-word;\n"], ["\n  white-space: pre-line;\n  word-break: break-word;\n"])));
var StyledTypography = styled(Typography)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  color: initial;\n  padding: 10px 0;\n"], ["\n  color: initial;\n  padding: 10px 0;\n"])));
var ConfirmationDialog = function (_a) {
    var open = _a.open, onClose = _a.onClose, role = _a.role, roaster = _a.roaster, itemType = _a.itemType, requestItems = _a.requestItems, requestBids = _a.requestBids, values = _a.values, deliveryRequestGroup = _a.deliveryRequestGroup;
    var _b = useTranslation(), t = _b.t, i18n = _b.i18n;
    var navigate = useNavigate();
    var notify = useNotify();
    var createDirectOrder = useRequest(orderApi.create);
    var createTypicaStockOrder = useRequest(orderApi.createTypicaStockOrder);
    var _c = React.useState(false), loading = _c[0], setLoading = _c[1];
    var _d = React.useState(false), agree = _d[0], setAgree = _d[1];
    var _e = React.useState({}), buyPartialByOfferId = _e[0], setBuyPartialByOfferId = _e[1];
    React.useEffect(function () {
        setBuyPartialByOfferId(requestBids.reduce(function (obj, bid) {
            obj[bid.offerId] = true;
            return obj;
        }, {}));
    }, [requestBids]);
    var request = React.useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(itemType === 'Offer')) return [3 /*break*/, 2];
                    return [4 /*yield*/, createDirectOrder({
                            roaster_id: roaster.id,
                            order: values,
                            items: requestItems.map(function (_a) {
                                var orderedItemId = _a.orderedItemId, quantity = _a.quantity, subTotalDiscount = _a.subTotalDiscount, typicaHandlingFeeDiscount = _a.typicaHandlingFeeDiscount, totalFeeDiscount = _a.totalFeeDiscount;
                                return ({
                                    offer_id: orderedItemId,
                                    quantity: quantity,
                                    sub_total_discount: subTotalDiscount !== null && subTotalDiscount !== void 0 ? subTotalDiscount : 0,
                                    typica_handling_fee_discount: typicaHandlingFeeDiscount !== null && typicaHandlingFeeDiscount !== void 0 ? typicaHandlingFeeDiscount : 0,
                                    total_fee_discount: totalFeeDiscount !== null && totalFeeDiscount !== void 0 ? totalFeeDiscount : 0,
                                });
                            }),
                            bids: requestBids.map(function (bid) { return ({
                                offer_id: bid.offerId,
                                fob_price: bid.fobPrice,
                                fob_price_usd_per_lb: bid.fobPriceUsdPerLb,
                                quantity: bid.quantity,
                                buy_partial: buyPartialByOfferId[bid.offerId],
                            }); }),
                        })];
                case 1: return [2 /*return*/, _a.sent()];
                case 2: return [4 /*yield*/, createTypicaStockOrder({
                        roaster_id: roaster.id,
                        order: values,
                        items: requestItems.map(function (_a) {
                            var orderedItemId = _a.orderedItemId, quantity = _a.quantity, subTotalDiscount = _a.subTotalDiscount, typicaHandlingFeeDiscount = _a.typicaHandlingFeeDiscount, totalFeeDiscount = _a.totalFeeDiscount;
                            return ({
                                typica_stock_item_id: orderedItemId,
                                quantity: quantity,
                                sub_total_discount: subTotalDiscount !== null && subTotalDiscount !== void 0 ? subTotalDiscount : 0,
                                typica_handling_fee_discount: typicaHandlingFeeDiscount !== null && typicaHandlingFeeDiscount !== void 0 ? typicaHandlingFeeDiscount : 0,
                                total_fee_discount: totalFeeDiscount !== null && totalFeeDiscount !== void 0 ? totalFeeDiscount : 0,
                            });
                        }),
                        delivery_request_group: deliveryRequestGroup && deliveryRequestGroup.address
                            ? {
                                address: {
                                    store_name: deliveryRequestGroup.address.storeName,
                                    person_name: deliveryRequestGroup.address.personName,
                                    name_kana: deliveryRequestGroup.address.nameKana,
                                    phone: deliveryRequestGroup.address.phone,
                                    country_calling_code: deliveryRequestGroup.address.countryCallingCode,
                                    email: deliveryRequestGroup.address.email,
                                    country_code: deliveryRequestGroup.address.countryCode,
                                    postal_code: deliveryRequestGroup.address.postalCode,
                                    prefecture: deliveryRequestGroup.address.prefecture,
                                    city: deliveryRequestGroup.address.city,
                                    address: deliveryRequestGroup.address.address,
                                    building: deliveryRequestGroup.address.building,
                                },
                                vat_number: deliveryRequestGroup.vatNumber,
                                campaign_code: deliveryRequestGroup.campaignCode,
                                items_and_request_dates: deliveryRequestGroup.itemsAndRequestDates.map(function (_a) {
                                    var itemsAttributes = _a.itemsAttributes, requestDate = _a.requestDate;
                                    return ({
                                        items_attributes: itemsAttributes.map(function (_a) {
                                            var orderedItemId = _a.orderedItemId, quantity = _a.quantity;
                                            return ({
                                                typica_stock_item_id: orderedItemId || '',
                                                quantity: quantity,
                                            });
                                        }),
                                        request_date: requestDate,
                                    });
                                }),
                            }
                            : undefined,
                    })];
                case 3: return [2 /*return*/, _a.sent()];
            }
        });
    }); }, [
        itemType,
        roaster.id,
        values,
        requestItems,
        requestBids,
        deliveryRequestGroup,
        createDirectOrder,
        createTypicaStockOrder,
        buyPartialByOfferId,
    ]);
    var handleConfirm = React.useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var response, message;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setLoading(true);
                    return [4 /*yield*/, request()];
                case 1:
                    response = _a.sent();
                    setLoading(false);
                    if (!response)
                        return [2 /*return*/];
                    message = itemType === 'TypicaStockItem'
                        ? t('messages.typicaStockOrderSuccess')
                        : t('messages.orderSuccess');
                    notify('success', [message]);
                    if (role === 'admin') {
                        navigate("/admin/orders/".concat(response.id));
                    }
                    else {
                        navigate("/roaster/orders/".concat(response.id));
                    }
                    return [2 /*return*/];
            }
        });
    }); }, [request, navigate, notify, role, t, itemType]);
    var isRoasterUs = React.useMemo(function () { return roaster.country.code === 'US'; }, [roaster]);
    return (React.createElement(Dialog, { title: t('messages.orderExplanationTitle'), open: open, onClose: onClose, actions: React.createElement(React.Fragment, null,
            React.createElement(Button, { onClick: handleConfirm, color: "primary", disabled: loading || !agree }, t('buttons.yes')),
            React.createElement(Button, { onClick: onClose, disabled: loading }, t('buttons.no'))) },
        React.createElement(ExplanationText, null,
            React.createElement(Trans, { i18nKey: "messages.".concat(isRoasterUs ? 'orderExplanationForUsBody' : 'orderExplanationBody') },
                React.createElement("a", { href: "/term.html?role=roaster&locale=".concat(i18n.language), target: "_blank", rel: "noopener noreferrer" }),
                React.createElement(DeliveryDocumentLink, { isRoasterUs: isRoasterUs, language: i18n.language, needJaDeliveryDocument: false }))),
        React.createElement("div", null,
            React.createElement(FormControlLabel, { control: React.createElement(Checkbox, { onChange: function (event) { return setAgree(event.target.checked); }, disabled: loading }), label: t('labels.agree') })),
        React.createElement(FormGroup, null,
            requestBids.length !== 0 && (React.createElement(React.Fragment, null,
                React.createElement(Box, { mt: 1 },
                    React.createElement(Divider, null)),
                React.createElement(StyledTypography, { variant: "h6" }, t('messages.auctionOrderExplanationTitle')))),
            requestBids.map(function (_a) {
                var offerId = _a.offerId, lotNumber = _a.lotNumber;
                return (React.createElement(FormControlLabel, { key: offerId, control: React.createElement(Checkbox, { onChange: function (event) {
                            var _a;
                            return setBuyPartialByOfferId(__assign(__assign({}, buyPartialByOfferId), (_a = {}, _a[offerId] = !event.target.checked, _a)));
                        }, disabled: loading }), label: t('pages.roasterOrder.confirmationOfBuyPartial', {
                        lotNumber: lotNumber,
                    }) }));
            }))));
};
export default ConfirmationDialog;
var templateObject_1, templateObject_2;
